import { css, keyframes } from "styled-components";

export const pulsingDotsAnimationBeforeKeyframe = keyframes`
  0% {
    box-shadow: 9984px 0 0 -5px;
  };
  30% {
    box-shadow: 9984px 0 0 2px;
  };
  60%, 100% {
    box-shadow: 9984px 0 0 -5px;
  };
`;
export const pulsingDotsAnimationBefore = css`${pulsingDotsAnimationBeforeKeyframe}`;

export const pulsingDotsAnimationAfterKeyframe = keyframes`
  0% {
    box-shadow: 10014px 0 0 -5px;
  };
  30% {
    box-shadow: 10014px 0 0 2px;
  };
  60%, 100% {
    box-shadow: 10014px 0 0 -5px;
  };
`;
export const pulsingDotsAnimationAfter = css`${pulsingDotsAnimationAfterKeyframe}`;

export const pulsingDotsAnimationMiddleKeyframe = keyframes`
  0% {
    box-shadow: 9999px 0 0 -5px;
  };
  30% {
    box-shadow: 9999px 0 0 2px;
  };
  60%, 100% {
    box-shadow: 9999px 0 0 -5px;
  };
`;
export const pulsingDotsAnimationMiddle = css`${pulsingDotsAnimationMiddleKeyframe}`;